import { render, staticRenderFns } from "./info.vue?vue&type=template&id=51727622&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=51727622&prod&lang=less"
import style1 from "./info.vue?vue&type=style&index=1&id=51727622&prod&lang=less&scoped=true"
import style2 from "./info.vue?vue&type=style&index=2&id=51727622&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51727622",
  null
  
)

export default component.exports